import BackendService from "../common/BackendService";

const sendMail = (vnMail: string, vnName?: string, vnVorname?: string) => {
    const params = {};

    const data = {
        vnMail,
        vnName,
        vnVorname
    }

    return BackendService.postData('rest/op/vvi/mail', params, data)
        .then(root => {
            return root.succ === true;

        }).catch(error => {
            // TODO Fuest logging
            throw error;
        });
}

const VviConsumer = {
    sendMail: sendMail
}

export default VviConsumer;